import React, { Component } from 'react';
import _ from 'lodash';

import LcSignsTable from '../components/LcSignsTable';
import LcSingsForm from '../components/LcSignsForm';
import LcSignsModel from '../components/LcSignsModel';
import ParkinglocationSelect from '../components/ParkinglocationSelect';
import UserModel from '../components/UserModel';
import { Layout, Button, Row, Col, Input, Icon, Switch, message } from 'antd';

class LcSignsScreen extends Component {

    state = {
        autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
        dataLoading: true,
        searchedTextValue: "",
        searchedDescriptionValue: "",
        dataAll: [],
        data: [],
        parkinglocationId: null,
        lcSignsFormModalVisible: null
    }

    intervalId = null;

    componentWillMount() {
        this.loadData(this.state.parkinglocationId);

        // Checking auto reload data
        this.intervalId = setInterval(() => {
            if (this.state.autoReload && this.state.parkinglocationId) {
                this.loadData(this.state.parkinglocationId);
            }
        }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    handlePing = (record) => {
        LcSignsModel.ping(record.serialNumber)
            .then((data) => {
                const updatedData = this.state.data.map(item => {
                    if (item.serialNumber === record.serialNumber) {
                        return {
                            ...item,
                            pingResult: data.pingTime
                        };
                    }
                    return item;
                });
                this.setState({ data: updatedData });
            })
            .catch(() => {
                message.error('Restart se nepodařilo odeslat!');
            });
    }

    filterData(dataAll, parkinglocationId, searchedTextValue, searchedDescriptionValue) {
        let data = parkinglocationId
            ? _.filter(dataAll, (d) => { return d['corelocationId'].startsWith(parkinglocationId); })
            : dataAll;
        if (searchedTextValue) {
            data = _.filter(data, (d) => { return d['serialNumber'].startsWith(searchedTextValue); });
        }
        if (searchedDescriptionValue) {
            data = _.filter(data, (d) => {
                return typeof (d['description']) === 'string' && d['description'].toLowerCase().includes(searchedDescriptionValue.toLowerCase());
            });
        }
        return data;
    }

    loadData(parkinglocationId) {
        this.setState({
            dataLoading: true
        });
        LcSignsModel.getAll()
            .then(data => {
                this.setState({
                    dataLoading: false,
                    dataAll: data,
                    data: this.filterData(data, parkinglocationId, this.state.searchedTextValue, this.state.searchedDescriptionValue)
                });
            })
            .catch(() => {
                message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
                this.setState({
                    dataLoading: false,
                });
            });
    }

    onSearch(searchText) {
        this.setState({
            data: this.filterData(this.state.dataAll, this.state.parkinglocationId, searchText, this.state.searchedDescriptionValue)
        });
    }
    onSearchDescription(searchText) {
        this.setState({
            data: this.filterData(this.state.dataAll, this.state.parkinglocationId, this.state.searchedTextValue, searchText)
        });
    }

    render() {
        return (
            <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
                <div style={{ padding: 24, background: '#fff' }}>
                    <h2>LC tabule - Seznam tabulí</h2>
                    <div style={{ marginBottom: '20px' }}>
                        <Row>
                            <Col span={16}>
                                <ParkinglocationSelect
                                    allowClear={true}
                                    onChange={(value) => {
                                        this.loadData(value);
                                        this.setState({ searchedTextValue: "", searchedDescriptionValue: "", parkinglocationId: value });
                                    }}
                                    style={{ width: 300 }} />
                                {' '}
                                <Input.Search
                                    placeholder="Najít seriové číslo"
                                    value={this.state.searchedTextValue}
                                    onSearch={this.onSearch.bind(this)}
                                    onChange={(e) => {
                                        this.setState({
                                            searchedTextValue: e.target.value
                                        })
                                    }}
                                    style={{ width: 200 }} />
                                <Input.Search
                                    placeholder="Najít popis"
                                    value={this.state.searchedDescriptionValue}
                                    onSearch={this.onSearchDescription.bind(this)}
                                    onChange={(e) => {
                                        this.setState({
                                            searchedDescriptionValue: e.target.value
                                        })
                                    }}
                                    style={{ width: 200 }} />
                            </Col>
                            <Col span={8} offset={0} style={{ textAlign: 'right' }}>
                                <Switch
                                    checked={this.state.autoReload}
                                    onChange={(checked) => {
                                        localStorage.setItem('table_autoReload', checked);
                                        this.setState({
                                            autoReload: checked
                                        });
                                    }} /> Automatická obnova
                                <Button type="default" onClick={() => { this.loadData(this.state.parkinglocationId) }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                                {UserModel.isInRoles(['ADMIN', 'LCSIGNS_SIGNS_WRITE'])
                                    ? <Button type="default" onClick={() => { this.setState({ lcSignsFormModalVisible: true }) }}>Nová tabule</Button>
                                    : null}
                            </Col>
                        </Row>
                    </div>
                    <LcSingsForm
                        type="modal"
                        modalVisible={this.state.lcSignsFormModalVisible}
                        onModalCancel={(form) => {
                            form.resetFields();
                            this.setState({ lcSignsFormModalVisible: false })
                        }}
                        onSuccess={(form, values) => {
                            LcSignsModel.create(values)
                                .then(() => {
                                    message.success("Tabule byla vložena!");
                                    form.resetFields();
                                    this.setState({ lcSignsFormModalVisible: false })
                                    this.loadData(this.state.coreParkinglocationId);
                                })
                                .catch((err) => {
                                    message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                                });
                        }} />
                    <LcSignsTable
                        data={this.state.data}
                        loading={this.state.dataLoading}
                        onPing={this.handlePing}
                        onRowRemoved={() => {
                            this.loadData(this.state.parkinglocationId);
                        }}
                        onAnyFormSuccess={() => {
                            this.loadData(this.state.parkinglocationId);
                        }} />
                </div>
            </Layout.Content>
        );
    }
}

export default LcSignsScreen;



// WEBPACK FOOTER //
// ./src/screens/LcSignsScreen.js